import AssistantImage from '@public/images/assistant/myta/assistant.jpg';
import { useStyles } from './styles';

export const VirtualAssistantIcon = ({
  isLargeButton,
}: {
  isLargeButton?: boolean;
}) => {
  const classes = useStyles(isLargeButton);

  return (
    <div style={classes.iconContainer} className="virtual-assistant-icon">
      <img style={classes.icon} src={AssistantImage} />
    </div>
  );
};
